import '@ampcore/adel-shim/dist/adel.amp.next.css'
import '@ampcore/adel-shim/dist/themes/theme.amp.next.css'
import '@webcomponents/webcomponentsjs/webcomponents-loader.js'
import '@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js'

import {
  initializeFeatureFlagOverrides,
  Environment
} from '@ampcore/client-side-services'

import './common/component-loader'
import './common/platform'
import './common/get-script-nonce'

import './custom-elements/AppStoreBanner'
import './custom-elements/AppBar'
import './custom-elements/BreadcrumbTrail'
import './custom-elements/AmeripriseFooter'
import './custom-elements/FooterDisclaimer'

import './utils/table-responsive/init'
import './utils/add-missing-alt/init'

import './components/OneTrust/index.js'
import './components/CardList/index.js'

import './utils/sitewideInterstitial'
import 'details-element-polyfill'
import './utils/override-qualtrics-eval-function'

initializeFeatureFlagOverrides()

declare global {
  interface Window {
    AMPSITEPATH?: string
    ENVIRONMENT?: Environment
    AMPCOMPATH?: string
  }
}

/**
 * Sets the webpack public path for loading assets.
 * @see https://webpack.js.org/guides/public-path/
 */

// @ts-expect-error: __webpack_public_path__ is a webpack global, not used directly
__webpack_public_path__ =
  typeof window.AMPSITEPATH === 'string'
    ? window.AMPSITEPATH
    : '/webfiles/latest/assets/ampsite/'
